let log = {
    name: "管理员",
    time: "时间",
    time_range: "时间区间",
    action: "操作",
    action_object: "操作对象",
    action_result: "结果",
    result_success: "成功",
    result_failed: "失败",
    result_exception: "异常",
    push_time: "推送时间",
    push_time_range: "推送时间区间",
    action_detail: "日志详情",
    action_descp: "操作内容"
}

export default log
